import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { NavLink, useHistory } from "react-router-dom";
import axios from "axios";

import HosteventBanner from "Assets/hostbanner.png";
import StaticBanner from "components/Banner/StaticBanner";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import { searchUrl } from "Api/Api";
import Footer from "../../components/Footer/Footer";
import { local_routes } from "utils/Routes";
import home from "Assets/home.svg";

const CityList = (props) => {
  const [locations, set_locations] = useState([]);
  const [locations_nested, set_locations_nested] = useState([]);
  const [loading, set_loading] = useState(true);

  const history = useHistory();

  const mainApiCall = async () => {
    let locations_response = await axios.get(
      `${searchUrl}locationsearch?coordinates_lat=0&coordinates_lon=0&radius=20038`
    );
    let locations_array = locations_response.data.search_query_results.map(
      (data) => data.entity_info
    );
    locations_array = locations_array.sort((a, b) =>
      a.entity_name > b.entity_name ? 1 : -1
    );

    // build nested lists
    let locations_array_nested = [];
    let number_of_columns = 4;
    let max_per_column = Math.ceil(locations_array.length / number_of_columns);
    for (
      let column_number = 0;
      column_number < number_of_columns;
      column_number++
    ) {
      locations_array_nested[column_number] = [];
      for (
        let i = column_number * max_per_column;
        i < column_number * max_per_column + max_per_column;
        i++
      ) {
        if (locations_array[i]) {
          locations_array_nested[column_number].push(locations_array[i]);
        }
      }
    }

    set_locations_nested(locations_array_nested);
    set_locations(locations_array);
    set_loading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    mainApiCall();
  }, []);

  const onSelectLocation = (location) => {
    history.push(local_routes.cities + "/" + location.friendly_url);
  };

  const nestedListRender = (nestedLists) => {
    return (
      <Container>
        <Row>
          <br />
          Now in {locations.length} Cities
          <br />
          <br />
        </Row>
        <Row>
          {nestedLists.map((nestedList, index) => (
            <Col sm={12} md={6} lg={3} key={index}>
              {nestedList.map((item) => (
                <Row key={item.entity_uuid}>
                  <div>
                    <NavLink to={local_routes.cities + "/" + item.friendly_url}>
                      {item.entity_name}
                    </NavLink>
                  </div>
                </Row>
              ))}
            </Col>
          ))}
        </Row>
      </Container>
    );
  };

  return (
    <React.Fragment>
      {loading ? (
        <FullPageSpinner />
      ) : (
        <React.Fragment>
          <Helmet>
            <title>PechaKucha Cities</title>
            <meta
              name="description"
              content="A list of all the PechaKucha cities around the world."
            />
          </Helmet>
          <StaticBanner
            link_out="https://pechakucha.typeform.com/to/oqOYtv"
            bannerImg={HosteventBanner}
            btnText="Apply Here"
            BannerHead="Cultivating Communities"
            BannerSubHead="PechaKucha Night - Bringing global communities together through creativity since 2003."
          />
          <div>
            {nestedListRender(locations_nested)}

            <Footer homeImg={home} homeImgRef="/" breadcrumbSubPage="Cities" />
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CityList;
